import { createLazySingleton } from '@/utils/singleton/createLazySingleton';
import { AdminUserListService } from './admin-user-list.service';
import { AssignRolePermissionService } from './assign-role-permission.service';
import { AssignRoleUserService } from './assign-role-user.service';
import { AttributeDeviceGroupService } from './attribute-device-group.service';
import { AttributeDeviceValueService } from './attribute-dvevice-value.service';
import { AuditLogService } from './audit-log.service';
import { BaseApiClient } from './base-api-client';
import { BusinessTripFormService } from './business-trip-form.service';
import { ComponentCategoryService } from './component-category.service';
import { ComponentDetailService } from './component-detail.service';
import { ComponentGroupService } from './component-group.service';
import { ComponentRequisitionService } from './component-requisition.service';
import { ComponentSKUService } from './component-sku.service';
import { ComponentSuggestionService } from './component-suggestion.service';
import { ComponentTypeService } from './component-type.service';
import { ConfigService } from './config.service';
import { CustomerContactService } from './customer-contact.service';
import { CustomerReviewService } from './customer-review.service';
import { CustomerService } from './customer.service';
import { DashboardV2Service } from './dashboard-v2.service';
import { DashboardService } from './dashboard.service';
import { DeviceGroupService } from './device-group.service';
import { DeviceModelService } from './device-model.service';
import { DeviceSKUService } from './device-sku.service';
import { DeviceTypeService } from './device-type.service';
import { DeviceService } from './device.service';
import { DynamicTaskService } from './dynamic-task.service';
import { DynamicTicketService } from './dynamic-ticket.service';
import { ErrorDetailTaskCheckService } from './error-detail-task-check.service';
import { ErrorDetailService } from './error-detail.service';
import { ErrorTypeService } from './error-type.service';
import { ExportFileService } from './export-file.service';
import { ImageStoreService } from './image-store.service';
import { NotificationV2Service } from './notification-v2.service';
import { NotificationService } from './notification.service';
import { OverviewUserListTaskCheckService } from './overview-user-list-task-check.service';
import { PermissionService } from './permission.service';
import { PriorityService } from './priority.service';
import { QualityManagementService } from './quality-management.service';
import { ReferenceCodeService } from './reference-code.service';
import { ReminderScheduleNotificationV2Service } from './reminder-schedule-notification-v2.service';
import { ReminderScheduleNotificationService } from './reminder-schedule-notification.service';
import { ReminderScheduleService } from './reminder-schedule.service';
import { ReportV2Service } from './report-v2.service';
import { RolePermissionService } from './role-permission.service';
import { RoleService } from './role.service';
import { SeverityLevelService } from './severity-level.service';
import { StaffCoordinationCustomerV2Service } from './staff-coordination-customer-v2.service';
import { StaffCoordinationCustomerService } from './staff-coordination-customer.service';
import { StaffCoordinationDeviceService } from './staff-coordination-device.service';
import { StaffCoordinationScheduleService } from './staff-coordination-schedule.service';
import { StaffCoordinationStaffService } from './staff-coordination-staff.service';
import { StaffCoordinationSuggestionV2Service } from './staff-coordination-suggestion-v2.service';
import { StaffCoordinationSuggestionService } from './staff-coordination-suggestion.service';
import { StaffCoordinationTaskService } from './staff-coordination-task.service';
import { StaffCoordinationTechnicianV2Service } from './staff-coordination-technician-v2.service';
import { StaffCoordinationTechnicianService } from './staff-coordination-technician.service';
import { StaffCoordinationTicketService } from './staff-coordination-ticket.service';
import { TaskCheckV2Service } from './task-check-v2.service';
import { TaskCheckService } from './task-check.service';
import { TaskRepeatService } from './task-repeat.service';
import { TaskTypeService } from './task-type.service';
import { TemplateCheckService } from './template-check.service';
import { TicketTypeService } from './ticket-type.service';
import { TicketService } from './ticket.service';
import { TranslationService } from './translation.service';
import { UsageTypeService } from './usage-type.service';
import { UserService } from './user.service';
import { ViolationDetailTaskCheckService } from './violation-detail-task-check.service';
import { ViolationDetailService } from './violation-detail.service';
import { ViolationTypeService } from './violation-type.service';

export * from '../graphQL/index';

export const baseApiClient = createLazySingleton(BaseApiClient);

export const attributeDeviceGroupService = createLazySingleton(
    () => new AttributeDeviceGroupService(baseApiClient())
);

export const attributeDeviceValueService = createLazySingleton(
    () => new AttributeDeviceValueService(baseApiClient())
);

export const taskCheckService = createLazySingleton(
    () => new TaskCheckService(baseApiClient())
);

export const taskCheckV2Service = createLazySingleton(
    () => new TaskCheckV2Service(baseApiClient())
);

export const deviceService = createLazySingleton(
    () => new DeviceService(baseApiClient())
);

export const templateCheckService = createLazySingleton(
    () => new TemplateCheckService(baseApiClient())
);

export const deviceGroupService = createLazySingleton(
    () => new DeviceGroupService(baseApiClient())
);

export const deviceTypeService = createLazySingleton(
    () => new DeviceTypeService(baseApiClient())
);

export const deviceSKUService = createLazySingleton(
    () => new DeviceSKUService(baseApiClient())
);

export const deviceModelService = createLazySingleton(
    () => new DeviceModelService(baseApiClient())
);

export const componentDetailService = createLazySingleton(
    () => new ComponentDetailService(baseApiClient())
);

export const componentCategoryService = createLazySingleton(
    () => new ComponentCategoryService(baseApiClient())
);

export const componentTypeService = createLazySingleton(
    () => new ComponentTypeService(baseApiClient())
);

export const componentGroupService = createLazySingleton(
    () => new ComponentGroupService(baseApiClient())
);

export const componentSKUService = createLazySingleton(
    () => new ComponentSKUService(baseApiClient())
);

export const customerService = createLazySingleton(
    () => new CustomerService(baseApiClient())
);

export const customerContactService = createLazySingleton(
    () => new CustomerContactService(baseApiClient())
);

export const errorDetailTaskCheckService = createLazySingleton(
    () => new ErrorDetailTaskCheckService(baseApiClient())
);

export const ticketService = createLazySingleton(
    () => new TicketService(baseApiClient())
);

export const ticketTypeService = createLazySingleton(
    () => new TicketTypeService(baseApiClient())
);

export const taskTypeService = createLazySingleton(
    () => new TaskTypeService(baseApiClient())
);

export const usageTypeService = createLazySingleton(
    () => new UsageTypeService(baseApiClient())
);

export const errorTypeService = createLazySingleton(
    () => new ErrorTypeService(baseApiClient())
);

export const errorDetailService = createLazySingleton(
    () => new ErrorDetailService(baseApiClient())
);

export const violationTypeService = createLazySingleton(
    () => new ViolationTypeService(baseApiClient())
);

export const violationDetailService = createLazySingleton(
    () => new ViolationDetailService(baseApiClient())
);

export const violationDetailTaskCheckService = createLazySingleton(
    () => new ViolationDetailTaskCheckService(baseApiClient())
);

export const severityLevelService = createLazySingleton(
    () => new SeverityLevelService(baseApiClient())
);

export const userService = createLazySingleton(
    () => new UserService(baseApiClient())
);

export const priorityService = createLazySingleton(
    () => new PriorityService(baseApiClient())
);

export const imageStoreService = createLazySingleton(
    () => new ImageStoreService(baseApiClient())
);

export const staffCoordinationCustomerService = createLazySingleton(
    () => new StaffCoordinationCustomerService(baseApiClient())
);

export const staffCoordinationDeviceService = createLazySingleton(
    () => new StaffCoordinationDeviceService(baseApiClient())
);

export const staffCoordinationTicketService = createLazySingleton(
    () => new StaffCoordinationTicketService(baseApiClient())
);

export const staffCoordinationTaskService = createLazySingleton(
    () => new StaffCoordinationTaskService(baseApiClient())
);

export const staffCoordinationSuggestionService = createLazySingleton(
    () => new StaffCoordinationSuggestionService(baseApiClient())
);

export const businessTripFormService = createLazySingleton(
    () => new BusinessTripFormService(baseApiClient())
);

export const staffCoordinationScheduleService = createLazySingleton(
    () => new StaffCoordinationScheduleService(baseApiClient())
);

export const componentRequisitionService = createLazySingleton(
    () => new ComponentRequisitionService(baseApiClient())
);

export const componentSuggestionService = createLazySingleton(
    () => new ComponentSuggestionService(baseApiClient())
);

export const customerReviewService = createLazySingleton(
    () => new CustomerReviewService(baseApiClient())
);

export const staffCoordinationTechnicianService = createLazySingleton(
    () => new StaffCoordinationTechnicianService(baseApiClient())
);

export const staffCoordinationStaffService = createLazySingleton(
    () => new StaffCoordinationStaffService(baseApiClient())
);

export const roleService = createLazySingleton(
    () => new RoleService(baseApiClient())
);

export const permissionService = createLazySingleton(
    () => new PermissionService(baseApiClient())
);

export const rolePermissionService = createLazySingleton(
    () => new RolePermissionService(baseApiClient())
);

export const adminUserListService = createLazySingleton(
    () => new AdminUserListService(baseApiClient())
);

export const qualityManagementService = createLazySingleton(
    () => new QualityManagementService(baseApiClient())
);

export const assignRoleUserService = createLazySingleton(
    () => new AssignRoleUserService(baseApiClient())
);

export const assignRolePermissionService = createLazySingleton(
    () => new AssignRolePermissionService(baseApiClient())
);

export const overviewUserListTaskCheckService = createLazySingleton(
    () => new OverviewUserListTaskCheckService(baseApiClient())
);

export const auditLogService = createLazySingleton(
    () => new AuditLogService(baseApiClient())
);

export const reminderScheduleService = createLazySingleton(
    () => new ReminderScheduleService(baseApiClient())
);

export const dashboardService = createLazySingleton(
    () => new DashboardService(baseApiClient())
);

export const taskRepeatService = createLazySingleton(
    () => new TaskRepeatService(baseApiClient())
);

export const notificationService = createLazySingleton(
    () => new NotificationService(baseApiClient())
);

export const reminderScheduleNotificationService = createLazySingleton(
    () => new ReminderScheduleNotificationService(baseApiClient())
);

export const exportFileService = createLazySingleton(
    () => new ExportFileService(baseApiClient())
);

export const referenceCodeService = createLazySingleton(
    () => new ReferenceCodeService(baseApiClient())
);

export const translationService = createLazySingleton(
    () => new TranslationService(baseApiClient())
);

export const dynamicTicketService = createLazySingleton(
    () => new DynamicTicketService(baseApiClient())
);

export const dynamicTaskService = createLazySingleton(
    () => new DynamicTaskService(baseApiClient())
);

export const dashboardV2Service = createLazySingleton(
    () => new DashboardV2Service(baseApiClient())
);

export const reportV2Service = createLazySingleton(
    () => new ReportV2Service(baseApiClient())
);

export const appConfigService = createLazySingleton(
    () => new ConfigService(baseApiClient())
);

export const staffCoordinationCustomerV2Service = createLazySingleton(
    () => new StaffCoordinationCustomerV2Service(baseApiClient())
);

export const staffCoordinationSuggestionV2Service = createLazySingleton(
    () => new StaffCoordinationSuggestionV2Service(baseApiClient())
);

export const staffCoordinationTechnicianV2Service = createLazySingleton(
    () => new StaffCoordinationTechnicianV2Service(baseApiClient())
);

export const notificationV2Service = createLazySingleton(
    () => new NotificationV2Service(baseApiClient())
);

export const reminderScheduleNotificationV2Service = createLazySingleton(
    () => new ReminderScheduleNotificationV2Service(baseApiClient())
);
